import { createContext, useContext, useEffect, useState } from 'react';
import { getAllTableData } from '../services/documentCenter';
import { DateFormats, formatDate } from '../utils/utils';
import { AuthStore } from './auth';

const date = new Date();

export type TransactionHistoryState = {
  documentCenter: [];
};

export const TransactionHistoryStore = createContext<TransactionHistoryState>({
  documentCenter: [],
});

const { Provider } = TransactionHistoryStore;

export const TransactionHistoryProvider = ({ children }: any) => {
  const [, , , selectedPersona] = useContext(AuthStore) || [];
  const [transactionHistoryState, setTransactionHistoryState] =
    useState<TransactionHistoryState>({
      documentCenter: [],
    });

  useEffect(() => {
    let count = 0;
    let documentCenter = getAllTableData(selectedPersona).map((x: any) => {
      count += 5;

      return {
        ...x,
        submitted: formatDate(
          new Date(date.getFullYear(), date.getMonth(), date.getDate() - count),
          DateFormats.US
        ),
      };
    });

    setTransactionHistoryState({
      documentCenter,
    });
  }, [selectedPersona]);

  return <Provider value={transactionHistoryState}>{children}</Provider>;
};
